import { render } from "./ViewLiquidationApproval.vue?vue&type=template&id=7725efcb"
import script from "./ViewLiquidationApproval.vue?vue&type=script&lang=js"
export * from "./ViewLiquidationApproval.vue?vue&type=script&lang=js"

import "./ViewLiquidationApproval.vue?vue&type=style&index=0&id=7725efcb&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__